import React from 'react';
import { useField } from 'formik';
import { FormGroup, Label, Input, FormFeedback, InputProps } from 'reactstrap';
import { useTranslator } from '../I18n/useTranslator';

interface FormikCheckboxInputProps extends InputProps {
  children?: React.ReactNode;
  translateErrMsg?: boolean;
  onCheckedStatusChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
}

const FormikCheckboxInput: React.FC<FormikCheckboxInputProps> = ({
  children,
  translateErrMsg = false,
  onCheckedStatusChange,
  name,
  ...props
}) => {
  // React treats radios and checkbox inputs differently than other input types.
  // Formik does this too! When you specify `type` to useField(), it will
  // return the correct bag of props for you -- a `checked` prop will be included
  // in `field` alongside `name`, `value`, `onChange`, and `onBlur`.
  const [field, meta] = useField({ name, type: 'checkbox' });
  const { t } = useTranslator();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onCheckedStatusChange) {
      onCheckedStatusChange(e);
    }
    field.onChange(e);
  };

  return (
    <FormGroup check className="text-start">
      <Label check className={meta.touched && meta.error ? 'is-invalid' : ''}>
        <Input type="checkbox" {...field} {...props} onChange={handleOnChange} />
        {children}
      </Label>
      {meta.touched && meta.error && (
        <FormFeedback>{translateErrMsg ? t(meta.error) : meta.error}</FormFeedback>
      )}
    </FormGroup>
  );
};

export default FormikCheckboxInput;
